'use client';

import { ChevronLeftIcon } from '@heroicons/react/20/solid';
import Link from 'next/link';
import { Logo } from './logo';
import { useCurrentFlowStep } from '~/lib/flow-steps';
import { useFormContext } from '~/lib/providers/form-context';

export function MobileFlowHeader() {
  const { goToPreviousStep } = useFormContext();
  const match = useCurrentFlowStep();

  if (!match || match.step.key === 'confirmation') {
    return (
      <header className="sticky top-0 z-10 flex items-center justify-between bg-surface-1 px-4 py-4 lg:hidden">
        <Link href="/" aria-label="Homepage" className="inline-flex">
          <Logo size="md" className="w-28" />
        </Link>
      </header>
    );
  }

  const { index, total } = match;
  const progress = ((index + 1) / total) * 100;

  return (
    <header className="sticky top-0 z-10 flex flex-col bg-surface-1 lg:hidden">
      <div
        className="relative h-1 bg-border"
        role="progressbar"
        aria-label={`Application progress, step ${index + 1} of ${total}`}
        aria-valuemin={0}
        aria-valuemax={total}
        aria-valuenow={index + 1}
      >
        <div
          className="absolute inset-y-0 left-0 w-(--progress) bg-accent transition-[width] duration-300"
          style={{ '--progress': `${progress}%` } as React.CSSProperties}
        />
      </div>
      <div className="flex items-center justify-between gap-x-3 px-4 py-3">
        <button
          type="button"
          onClick={goToPreviousStep}
          aria-label="Back"
          className="-ml-1.5 inline-flex size-8 items-center justify-center rounded-full text-fg-muted transition-colors hover:text-fg"
        >
          <ChevronLeftIcon className="size-5" aria-hidden="true" />
        </button>
        <Link href="/" aria-label="Homepage" className="inline-flex">
          <Logo size="md" className="w-24" />
        </Link>
        <p className="font-mono text-xs font-semibold tracking-[0.12em] text-fg-faint tabular-nums">
          {String(index + 1).padStart(2, '0')} / {String(total).padStart(2, '0')}
        </p>
      </div>
      <div
        aria-hidden="true"
        className="pointer-events-none absolute top-full right-0 left-0 h-6 bg-linear-to-b from-surface-1 to-transparent"
      />
    </header>
  );
}
